import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_process_instance_line_RowClass} from '../../dbschema/bl_mrp_process_instance_line.model';

export class MrpProcessInstanceLinesContainerModel extends BaseContainerModel {
  bl_mrp_process_instance_line: bl_mrp_process_instance_line_RowClass
}
